import { render, staticRenderFns } from "./HomeGenerico.vue?vue&type=template&id=1aa3e91e&scoped=true&"
import script from "./HomeGenerico.vue?vue&type=script&lang=ts&"
export * from "./HomeGenerico.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa3e91e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1aa3e91e', component.options)
    } else {
      api.reload('1aa3e91e', component.options)
    }
    module.hot.accept("./HomeGenerico.vue?vue&type=template&id=1aa3e91e&scoped=true&", function () {
      api.rerender('1aa3e91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiApp/HomeGenerico.vue"
export default component.exports